/*
 * Desplegables del tema (filas de «collapsible-content» y pestañas de la ficha de producto):
 * - solo una fila abierta a la vez dentro de cada sección: al abrir una, las demás de esa sección se pliegan;
 * - abrir y plegar animan la altura del contenido, y la fila que se cierra y la que se abre se mueven a la vez.
 * La sección «imagen desplegable» lleva su propia animación y no pasa por aquí.
 */
(function () {
  'use strict';

  var DURATION = 320;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  // Las filas de «collapsible-content» llevan su propia animación y exclusividad en la sección: aquí solo el resto.
  var GROUP = '.accordion details';
  function mine(details) {
    return details.matches(GROUP) && !details.closest('.collapsible-content');
  }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  // La flecha gira a la vez que se mueve el contenido, también al cerrar (el atributo open se quita al final).
  var style = document.createElement('style');
  style.textContent =
    '.accordion details > summary .icon-caret, .accordion details > summary .accordion__caret { transition: transform ' + DURATION + 'ms ' + EASING + '; }' +
    '.accordion details.hm-acc-closing > summary .icon-caret, .accordion details.hm-acc-closing > summary .accordion__caret { transform: rotate(0deg) !important; }';
  document.head.appendChild(style);

  function panelOf(details) {
    return details.querySelector(':scope > .accordion__content');
  }

  function stop(panel) {
    if (panel && panel._hmAnim) {
      var running = panel._hmAnim;
      panel._hmAnim = null;
      running.cancel();
    }
    if (panel) panel._hmClosing = false;
  }

  function settle(details, panel) {
    panel.style.overflow = '';
    panel._hmAnim = null;
    details.classList.remove('hm-acc-anim', 'hm-acc-closing');
  }

  function open(details) {
    var panel = panelOf(details);
    if (details.open && !(panel && panel._hmClosing)) return;
    if (panel) panel._hmClosing = false;
    if (!panel || reduced.matches || !details.animate) {
      details.open = true;
      return;
    }
    stop(panel);
    details.open = true;
    var style = getComputedStyle(panel);
    var height = panel.offsetHeight;
    var margin = style.marginBottom;
    details.classList.add('hm-acc-anim');
    panel.style.overflow = 'hidden';
    panel._hmAnim = panel.animate(
      [
        { height: '0px', marginBottom: '0px', opacity: 0 },
        { height: height + 'px', marginBottom: margin, opacity: 1 },
      ],
      { duration: DURATION, easing: EASING }
    );
    var opening = panel._hmAnim;
    opening.onfinish = function () {
      if (panel._hmAnim === opening) settle(details, panel);
    };
  }

  function close(details) {
    var panel = panelOf(details);
    if (!details.open || (panel && panel._hmClosing)) return;
    if (!panel || reduced.matches || !details.animate) {
      details.open = false;
      return;
    }
    stop(panel);
    var style = getComputedStyle(panel);
    var height = panel.offsetHeight;
    var margin = style.marginBottom;
    panel._hmClosing = true;
    details.classList.add('hm-acc-anim', 'hm-acc-closing');
    panel.style.overflow = 'hidden';
    panel._hmAnim = panel.animate(
      [
        { height: height + 'px', marginBottom: margin, opacity: 1 },
        { height: '0px', marginBottom: '0px', opacity: 0 },
      ],
      { duration: DURATION, easing: EASING }
    );
    var closing = panel._hmAnim;
    closing.onfinish = function () {
      if (panel._hmAnim !== closing) return;
      panel._hmClosing = false;
      details.open = false;
      settle(details, panel);
    };
  }

  function closeOthers(details) {
    var section = details.closest('.shopify-section');
    if (!section) return;
    section.querySelectorAll(GROUP).forEach(function (other) {
      if (other !== details && other.open && mine(other)) close(other);
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !mine(details) || !panelOf(details)) return;
    event.preventDefault();
    var panel = panelOf(details);
    if (details.open && !panel._hmClosing) {
      close(details);
    } else {
      closeOthers(details);
      open(details);
    }
  });

  // Aperturas hechas por otros scripts (sin pasar por el clic): las demás filas se pliegan igual.
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open || !mine(details)) return;
      closeOthers(details);
    },
    true
  );
})();
